import { useEffect } from 'react'

// Capture also observes nested scrollers and portals without a listener per panel.
export const useScrollbarVisibility = () => {
  useEffect(() => {
    const timers = new Map<Element, number>()

    const onScroll = (event: Event) => {
      const element = event.target === document ? document.scrollingElement : event.target
      if (!(element instanceof Element) || element.hasAttribute('data-scrollbar-always-visible')) return

      window.clearTimeout(timers.get(element))
      element.setAttribute('data-scrollbar-active', '')
      timers.set(
        element,
        window.setTimeout(() => {
          element.removeAttribute('data-scrollbar-active')
          timers.delete(element)
        }, 900)
      )
    }

    document.addEventListener('scroll', onScroll, { capture: true, passive: true })
    return () => {
      document.removeEventListener('scroll', onScroll, true)
      timers.forEach((timer, element) => {
        window.clearTimeout(timer)
        element.removeAttribute('data-scrollbar-active')
      })
    }
  }, [])
}
